import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.cluster.users');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-cluster-users',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.cluster.users/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.users-filters {
  margin: 16px 0;
  gap: 10px;
}

.users-filters > input {
  flex: 1;
  min-width: 180px;
}

.users-filters select {
  width: auto;
}

.users-name {
  background: none;
  border: 0;
  padding: 0;
  color: #5145e5;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  text-align: left;
}

.users-name:hover {
  text-decoration: underline;
}

.users-coverage {
  align-self: end;
}

.users-connection {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid #e2e5ec;
  border-radius: 8px;
  background: #fff;
}

.users-connection summary, .users-diagnostics summary {
  cursor: pointer;
  font-weight: 600;
}

.users-connection .access-controls {
  margin-top: 16px;
}

.users-diagnostics {
  margin-top: 16px;
}

.users-diagnostic {
  border-top: 1px solid #e2e5ec;
  padding-top: 12px;
  margin-top: 12px;
  overflow-wrap: anywhere;
}

.users-diagnostic small {
  display: block;
  color: #8790a3;
  margin-top: 4px;
}

.users-detail {
  width: min(1120px, 100vw - 32px);
  max-width: 1120px;
}

.users-detail h2 {
  margin: 0;
}

.users-detail .access-controls {
  margin: 16px 0;
}

.users-detail .access-table-wrap {
  margin-top: 16px;
}

.users-detail-footer {
  justify-content: flex-end;
  margin-top: 20px;
}

.users-result-error {
  max-width: 300px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  color: #b23c3c;
  font-size: 12px;
}

@media (max-width: 700px) {
  .users-detail {
    width: calc(100vw - 24px);
    padding: 16px;
  }
  .users-filters {
    align-items: stretch;
  }
  .users-filters > input, .users-filters select {
    width: 100%;
    flex-basis: 100%;
  }
}
.users-filters input[type=checkbox] {
  width: 16px;
  height: 16px;
  min-width: 16px;
  flex: none;
}`],
})
export class PageKieraClusterUsersComponent implements OnInit {
    public clusterId: number = 0;
    public tab: string = 'users';
    public data: any = { clusters: [], users: [], nodes: [], audit: { rows: [], total: 0 } };
    public detail: any = null;
    public selectedName: string = '';
    public detailLoading: boolean = false;
    public loading: boolean = false;
    public busy: boolean = false;
    public error: string = '';
    public detailError: string = '';
    public connectionError: string = '';
    public notice: string = '';
    public partial: boolean = false;
    public sshUser: string = '';
    public sshPort: number = 22;
    public sudoPassword: string = '';
    public collectNodeId: number = 0;
    public search: string = '';
    public showSystem: boolean = false;
    public stateFilter: string = '';
    public page: number = 1;
    public pageSize: number = 20;
    public auditPage: number = 1;
    public auditSearch: string = '';
    public results: any[] = [];
    public completed: number = 0;
    public total: number = 0;
    private detailRequest: number = 0;

    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(location.search);
        this.clusterId = Number(params.get('cluster') || 0);
        this.sshUser = params.get('ssh_user') || '';
        this.sshPort = Number(params.get('ssh_port') || 22);
        await this.load();
        const name = params.get('user');
        if (name) await this.openUser({ name });
    }
    public t(ko: string, en: string) { return String(this.service.lang.get() || 'ko').startsWith('en') ? en : ko; }
    public can(action: string) { return this.service.auth.can('cluster_users', action); }
    private async api(action: string, fields: any = {}, execution: boolean = false) {
        const response = await wiz.call(action, { cluster_id: this.clusterId, ...fields,
            ...(execution ? { ssh_user: this.sshUser, ssh_port: this.sshPort,
                ...(this.sudoPassword ? { sudo_password: this.sudoPassword } : {}) } : {}) });
        if (response.code !== 200) throw new Error(response.data?.message || this.t('요청을 처리하지 못했습니다.', 'The request failed.'));
        return response.data;
    }
    public async load() {
        this.loading = true; this.error = ''; await this.service.render();
        try {
            this.data = await this.api('directory', { page: this.auditPage, dump: 20, search: this.auditSearch });
            this.clusterId = Number(this.data.cluster_id || 0);
        } catch (e) { this.error = String(e?.message || e); }
        finally { this.loading = false; await this.service.render(); }
    }
    public async clusterChanged() {
        this.detailRequest++; this.detail = null; this.selectedName = ''; this.detailLoading = false;
        this.sudoPassword = ''; this.collectNodeId = 0; this.results = [];
        this.page = 1; this.auditPage = 1; this.notice = ''; this.connectionError = '';
        await this.load();
    }
    public async changeTab(tab: string) { this.tab = tab; await this.service.render(); }
    public async filtersChanged() { this.page = 1; await this.service.render(); }
    public rows() {
        const needle = this.search.trim().toLowerCase();
        return this.data.users.filter((row: any) => (this.showSystem || !row.system)
            && (!this.stateFilter || row.state === this.stateFilter)
            && (!needle || [row.name, row.comment, ...row.groups].some((v: any) => String(v || '').toLowerCase().includes(needle))));
    }
    public paged() { return this.rows().slice((this.page - 1) * this.pageSize, this.page * this.pageSize); }
    public async turn(delta: number) { this.page = Math.max(1, this.page + delta); await this.service.render(); }
    public failedNodes() { return this.data.nodes.filter((row: any) => row.error); }
    public collectedNodes() { return this.data.nodes.filter((row: any) => row.checked_at && row.has_users !== false).length; }
    public stateLabel(state: string) {
        const values: any = { allowed: ['허용', 'Allowed'], denied: ['비허용', 'Denied'],
            mixed: ['노드별로 다름', 'Mixed'], unverified: ['확인 필요', 'Needs verification'] };
        return values[state] ? this.t(values[state][0], values[state][1]) : this.t('미수집', 'Not collected');
    }
    public async openUser(row: any) {
        const request = ++this.detailRequest;
        this.selectedName = row.name; this.detail = null; this.detailLoading = true;
        this.detailError = ''; this.results = []; this.notice = ''; await this.service.render();
        try {
            const detail = await this.api('user_detail', { name: row.name });
            if (request === this.detailRequest) this.detail = detail;
        } catch (e) { if (request === this.detailRequest) this.detailError = String(e?.message || e); }
        finally { if (request === this.detailRequest) { this.detailLoading = false; await this.service.render(); } }
    }
    public async closeDetail() {
        if (this.busy) return;
        this.detailRequest++; this.selectedName = ''; this.detail = null; this.detailLoading = false;
        this.detailError = ''; this.sudoPassword = ''; await this.service.render();
    }
    public targets() { return (this.detail?.nodes || []).filter((row: any) => !row.system && row.deployed); }
    public resultFor(id: number) { return this.results.find((row: any) => Number(row.node_id) === Number(id)); }
    public async setAccess(allowed: boolean, node: any = null) {
        if (this.busy || !this.detail || !this.can('update')) return;
        const targets = node ? [node] : this.targets();
        if (!targets.length) return;
        const name = this.detail.name;
        const ok = await this.service.modal.show({ title: this.t('클러스터 접근 변경', 'Change cluster access'),
            message: name + this.t(' 사용자의 계정이 확인된 ', ' on ') + targets.length
                + this.t('개 노드에 접근 ', ' nodes: ')
                + (allowed ? this.t('허용을 적용할까요?', 'allow access?') : this.t('비허용을 적용할까요? 기존 세션은 유지됩니다.', 'deny new logins? Existing sessions remain open.')),
            action: allowed ? this.t('허용', 'Allow') : this.t('비허용', 'Deny'), cancel: this.t('취소', 'Cancel'),
            status: 'warning', actionBtn: allowed ? 'success' : 'error' });
        if (!ok) return;
        this.busy = true; this.results = []; this.detailError = ''; this.notice = '';
        this.completed = 0; this.total = targets.length; await this.service.render();
        try {
            for (let offset = 0; offset < targets.length; offset += 2) {
                const batch = targets.slice(offset, offset + 2);
                try {
                    const result = await this.api('access_set', { name, allowed: String(allowed),
                        node_ids: JSON.stringify(batch.map((row: any) => row.id)) }, true);
                    this.results.push(...result.results);
                } catch (e) {
                    this.results.push(...batch.map((row: any) => ({ node_id: row.id, ok: false, error: String(e?.message || e) })));
                }
                this.completed += batch.length; await this.service.render();
            }
            const success = this.results.filter((row: any) => row.ok).length;
            this.partial = success !== targets.length;
            this.notice = success + ' / ' + targets.length + this.t('개 노드 적용 확인. ', ' nodes confirmed. ')
                + (this.partial ? this.t('실패한 노드는 상세 결과를 확인하세요.', 'Review failed nodes below.') : this.t('적용을 완료했습니다.', 'Completed.'));
            await this.load();
            this.detail = await this.api('user_detail', { name });
        } catch (e) { this.detailError = String(e?.message || e); }
        finally { this.busy = false; await this.service.render(); }
    }
    public async collectNode() {
        if (this.busy || !this.collectNodeId) return;
        this.busy = true; this.connectionError = ''; this.notice = ''; await this.service.render();
        try {
            await this.api('collect', { node_id: this.collectNodeId }, true);
            this.partial = false; this.notice = this.t('선택한 노드의 사용자 목록을 수집했습니다.', 'User inventory collected from the selected node.');
            await this.load();
        } catch (e) { this.connectionError = String(e?.message || e); }
        finally { this.busy = false; await this.service.render(); }
    }
    public async userLogs() {
        this.auditSearch = this.selectedName; this.auditPage = 1;
        await this.closeDetail(); this.tab = 'audit'; await this.load();
    }
    public async auditTurn(delta: number) { this.auditPage = Math.max(1, this.auditPage + delta); await this.load(); }
    public actionLabel(action: string) {
        const labels: any = { access_allow: ['접근 허용', 'Access allowed'], access_deny: ['접근 비허용', 'Access denied'],
            inventory_refresh: ['사용자 수집', 'User collection'], user_save: ['사용자 저장', 'User saved'],
            user_lock: ['로그인 잠금 변경', 'Login lock changed'], user_remove: ['사용자 삭제', 'User removed'],
            group_save: ['그룹 저장', 'Group saved'], group_remove: ['그룹 삭제', 'Group removed'],
            session_terminate: ['세션 종료', 'Session terminated'] };
        return labels[action] ? this.t(labels[action][0], labels[action][1]) : action;
    }
    public formatDate(value: any) { return value ? new Date(value).toLocaleString(this.t('ko-KR', 'en-US')) : '—'; }
}

export default PageKieraClusterUsersComponent;
